import React from 'react';

import API from '@beardeddevops/react.api';
import Framework from "@beardeddevops/react.framework"
import {Objects, Types, Collections} from "components";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import classNames from "classnames";
import UserRoles from "../../../../../constants/UserRoles";
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Select from "react-select";
import TextField from "@material-ui/core/TextField";
import moment from "moment";


const breadcrumbsStatic = [{
	name: 'Tickets',
	url: '/tickets',
	icon: 'ticket',
}];

class Ticket extends Framework.Components.View {

	constructor(props) {
		super(props,"details");

		this.state = {
			...this.state,
			name: '',
			tickets_notess: [],
			forms: [],
			selectedForm: {value: "CompletionCertificate", label: "Completion Certificate"}
		}
		this.state.tickets_notess = [];

		this.userModel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.setCustomerID = this.setCustomerID.bind(this)
		this.getForms();
	}

	getForms = async () => {
		let forms = new API.BuildClass(Types.Forms._name, API.RequestType.READ_ALL);
		forms = await forms.submit(null, API.RequestType.READ_ALL)
		forms = forms.items.map((form) => {return form.name.replace(/([A-Z])/g, ' $1').trim().split("_")[0];});
		forms = [...new Set(forms)];//removes duplicates
		this.setState({forms: forms});
	}

	handleData = (data) => {
		this.setState({name: data.summary});
	}

	handleNotesLoad = async (tickets_notess) => {
		let authors = [];

		// Fetch user metadata for name display from note.creator user pkey
		for (let i = 0, len = tickets_notess.length; i < len; i++) {
			let note = tickets_notess[i];
			let user;

			if (!note.creator) continue;

			user = authors.find((author) => author.pkey === note.creator);

			if (!user) {
				this.userModel.object.pkey = note.creator;

				try {
					user = await this.userModel.submit(null, API.RequestType.READ);
				} catch (e) {
					console.error('Error fetching user', e);
					continue;
				}

				authors.push(user);
			}

			note.creator = user;
		}

		this.setState({tickets_notess});
	}
	setCustomerID(id,location,financial){
		console.log("fin change", financial)
		this.setState({customerID:id,locationID:location,ticketFinancial:financial})
	}
    handleAfterSave = async(data)=>{
		if(data.pkey !== this.state.locationID)
		{
			let model = API.BuildClass(Types.Tickets._name , API.RequestType.READ)
			this.update = 'POST'
			model.object = this.state;
			model.object.pkey = this.props.match.params.id;
			model.object.location = data.pkey;
			await model.submit(null,this.update,true)
		}
	}

	toggleClose = () => {
		this.setState({showForms: false, signForm: false})
	}

	render() {
		let {match, history, reloadShell, baseUrl} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name:` Ticket ${match.params.id}`,
				url: `/tickets/${match.params.id}`,
				icon: 'ticket',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}>
					{this.props.rootState.roles.some(role => [UserRoles.FieldEngineer].includes(role)) &&
					<Button data-cy="sign-form" onClick={this.toggle('showForms')} size={"sm"} color="primary">
						Sign Form
					</Button>}
				</Framework.Components.PageBar>

				<Tabs
					value={this.state.tab}
					onChange={this.handleTabChange}
					component={'div'}>
					<Tab label="Details" value="details"/>
					<Tab label="Notes" value="notes"/>
					<Tab label="Financial" value="financial"/>
					<Tab label="Site Checklist" value="checklist"/>
					{this.props.rootState.roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) && <Tab label="Change Log" value="logs"/>}
					{this.props.rootState.roles.some(role => [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk].includes(role)) && this.state.manager_override_signature && <Tab label="Manager Override" value="override"/>}
					{this.props.rootState.roles.some(role => [UserRoles.Admin, UserRoles.Manager].includes(role)) && <Tab label="Signed Forms" value="forms"/>}
				</Tabs>

				<Modal
					isOpen={this.state.showForms}
					toggle={this.toggleClose}
					size={'md'}
					backdrop={true}
				>
					<ModalHeader toggle={this.toggleClose}>
						Form Selection
					</ModalHeader>
					<ModalBody>
						<div className={'row'}>
							<div className={'col-10'}>
								<Select
									placeholder={"Form Selection"}
									value={this.state.selectedForm}
									onChange={(form) => {this.setState({selectedForm: form})}}
									options={this.state.forms.map(form => {
										return (
											{value: form.replaceAll(" ", ""), label: form})
									})}
								/>
							</div>
							<div className={'col-2'}>
								<Button onClick={this.toggle('signForm')} color={'primary'}>
									Sign
								</Button>
							</div>
						</div>
					</ModalBody>
				</Modal>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={this.state.selectedForm.label}
					object={Objects[this.state.selectedForm.value]}
					history={this.props.history}
					toggle={this.state.signForm}
					reportClose={this.reportClose('signForm')}
					objectProps={{ ticket: match.params.id}}
					reloadPage={this.refreshPage}
					hasSubmit={false}
					afterSave={() => {this.setState({signForm: false})}}
				/>

				<div className={classNames({'hidden': this.state.tab !== 'forms'})}>
					<Collections.AllWaivers
						roles={this.props.rootState.roles}
						history={history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						regions={this.props.regions}
						filterTicket={match.params.id}
					/>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'logs'})}>
					<Collections.LogsTicket
						parent={match.params.id}
						roles={this.props.rootState.roles}
						history={history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						regions={this.props.regions}
						showCSV={this.props.rootState.roles.includes(UserRoles.Admin)}
					/>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'notes'})}>
					<Objects.TicketNote
						ticket={match.params.id}
						parent={match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={baseUrl}
						noDelete={false}
						goBack={true}
					/>
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'financial'})}>
					<Objects.Financial
						id={this.state.ticketFinancial ?? null}
						ticket={match.params.id}
						parent={match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={`/tickets`}
						noDelete={false}
						goBack={false}
						setManagerOverride={(name) => this.setState({manager_override_approver: name})}
					/>
				</div>


				<div className={classNames({'hidden': this.state.tab !== 'override' })}>
					{this.state.manager_override_signature && <div style={{paddingTop: 5}} className={'row'}>
						<div className={'col-6'}>
							<h4 className="section-title">Approving Manager</h4>
							<div className="form-group">
								<TextField
									fullWidth
									margin="dense"
									variant="outlined"
									name="manager_overrider"
									label="Approving Manager"
									value={this.state.manager_override_approver}
									disabled={true}
								/>
							</div>
						</div>
						<div className={'col-6'}>
							<h4 className="section-title">Signature Date</h4>
							<div className="form-group">
								<TextField
									fullWidth
									margin="dense"
									variant="outlined"
									name="date"
									label="Signature Date"
									value={moment(this.state.manager_override_signature_date).format('M/D/Y')}
									disabled={true}
								/>
							</div>
						</div>
						<div className={'col-12'} style={{display: 'grid'}}>
							<h4 className="section-title">Signature Recorded</h4>
							<b style={{justifySelf: 'center'}}>You are approving that A MANAGER authorized this change. If this was NOT approved, you are signing authorization for Karls Technology to bill you this amount.</b>
							<img width={'90%'} height={'50%'} src={this.state.manager_override_signature} alt={'Signature'}/>
						</div>
					</div>}
				</div>

				<div className={classNames({'hidden': this.state.tab !== 'checklist'})}>
					<Objects.TicketCheckList
						ticket={match.params.id}
						parent={match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={baseUrl}
						noDelete={false}
						goBack={true}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'details'})}>
					<div className={"row"}>
						<div className={"col"}>
							<Objects.TicketDetails
								id={match.params.id}
								handle={this.setCustomerID}
								history={this.props.history}
								reloadShell={this.props.reloadShell}
								reloadPage={this.refreshPage}
								reloadSelf={this.state.refresh}
								updateName={this.updateName}
								baseUrl={baseUrl}
								noDelete={false}
								goBack={true}
								setSignature={(date, signature) => this.setState({manager_override_signature_date: date, manager_override_signature: signature})}
							/>
						</div>
					</div>
					<div className={"row"}>
						<div className={"col-6"}>
							<Objects.Customer
								id={this.state.customerID}
								history={history}
								noDelete={false}
							/>
						</div>
						<div className={"col-6"}>
							<Objects.CustomerLocation
								id={this.state.locationID}
								parent={this.state.customerID}
								history={history}
								noDelete={false}
								afterSave ={this.handleAfterSave}
							/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Framework.Components.withRootState(Ticket);
